import axios from "axios";
import {computed, ref} from "vue";
import {getIndustryContent} from "@/composables/industry-content/useIndustryContent";

const Steps = computed(() => ({
  ONBOARDING: {
    key: 'onboarding',
    inProgressBar: false,
  },
  LOCATIONS: {
    key: 'locations',
    title: 'Locations',
    description: getIndustryContent('steps.locations.step-description'),
    actionTime: '2 mins',
    heading: getIndustryContent('steps.locations.heading'),
    helpUrl: 'https://player.vimeo.com/video/1053332710?h=e9b01c650c',
    inProgressBar: true,
    stepsToFill: 1,
  },
  BUSINESS_DESCRIPTION: {
    key: 'business-description',
    title: 'Description',
    description: 'To attract the right leads, tell me what makes your business unique.',
    actionTime: '3 mins',
    heading: 'What makes your business unique?',
    helpUrl: 'https://player.vimeo.com/video/1053346173?h=69b0bb08eb',
    inProgressBar: true,
    stepsToFill: 2,
  },
  COMPETITORS: {
    key: 'competitors',
    title: 'Competitors',
    description: 'Share your competitors so I can help you outrank them.',
    actionTime: '3 mins',
    heading: 'Who are your competitors?',
    helpUrl: 'https://player.vimeo.com/video/1053355865?h=82f7ef977a',
    inProgressBar: true,
    stepsToFill: 3,
  },
  SERVICES_OFFERED: {
    key: 'services-offered',
    title: 'Services',
    description: getIndustryContent('steps.services-offered.step-description'),
    actionTime: '3 mins',
    heading: getIndustryContent('steps.services-offered.heading'),
    helpUrl: 'https://player.vimeo.com/video/1053362132?h=154d2e554e',
    inProgressBar: true,
    stepsToFill: 4,
  },
  ACCOUNTS: {
    key: 'accounts',
    title: 'Accounts',
    description: 'Sync your Google accounts so I can use their insights.',
    actionTime: '2 mins',
    heading: 'Link your Google accounts',
    inProgressBar: true,
    stepsToFill: 5,
  },
  HOLDING: {
    key: 'holding',
    heading: 'I’m building your keyword strategy - sit tight!',
    inProgressBar: false,
    stepsToFill: 5,
    aiSummaryUrlPath: '/ajax/v2/ai-onboarding/ai-summary',
  },
  KEYWORDS: {
    key: 'keywords',
    title: 'Keywords',
    description: 'Review the SEO keywords I’ve chosen for you.',
    actionTime: '5 mins',
    heading: 'Review your new keywords',
    inProgressBar: true,
    stepsToFill: 6,
  },
  AI_AUTO_ASSIGN_HOLDING: {
    key: 'ai-auto-assign-holding',
    heading: 'I’m reviewing your website copy - sit tight!',
    inProgressBar: false,
    stepsToFill: 6,
    aiSummaryUrlPath: '/ajax/v2/strategy/ai-sitemap-summary'
  },
  PAGES: {
    key: 'pages',
    title: 'Pages',
    description: 'I’ve mapped the right pages for your new keywords.',
    actionTime: '5 mins',
    heading: 'Your SEO Strategy',
    inProgressBar: true,
    stepsToFill: 7,
  },
  ONSITE_OPTIMIZER: {
    key: 'onsite-optimizer',
    title: 'Install Snippet',
    heading: 'Install the Optimizer snippet',
    description: 'Install the Optimizer snippet to let me make SEO changes to your website.',
    actionTime: '5 mins',
    helpUrl: 'https://player.vimeo.com/video/929844758?h=4363ad5cae&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479',
    inProgressBar: true,
    stepsToFill: 8,
  },
}));

const saveCurrentStep = (step) => axios.post(
  '/ajax/v2/ai-onboarding/current-step/store',
  {currentStep: step.key}
);

const isSavingCurrentStep = ref(false);

const changeStep = async(step, emit) => {
  isSavingCurrentStep.value = true;

  await saveCurrentStep(step);

  isSavingCurrentStep.value = false;
  emit('changeStep', step);
};

export {
  Steps,
  saveCurrentStep,
  changeStep,
  isSavingCurrentStep
};
